// Estado de conversaciones en tiempo real (mensajes entrantes por SignalR).
// Portado de frontendcongress. Alimenta los badges de no leídos del chat y el
// aviso a expositores cuando alguien entra a su stand.

const initialState = {
  selectedParticipant: 0,
  participantsOnStand: [],
  // { [fromPersonId]: { unreadMessagesCount, unreadMessages: [] } }
  allUnreadMessages: {},
  // Para disparar un toast en cada entrada a stand (aunque la persona ya estuviera).
  lastStandEntry: null, // { fromPersonId, seq }
  standSeq: 0,
};

export default function conversationReducer(state = initialState, action) {
  switch (action.type) {
    case 'ENTER_STAND': {
      const seq = state.standSeq + 1;
      const already = state.participantsOnStand.indexOf(action.payload.fromPersonId) !== -1;
      return {
        ...state,
        participantsOnStand: already
          ? state.participantsOnStand
          : [...state.participantsOnStand, action.payload.fromPersonId],
        lastStandEntry: { fromPersonId: action.payload.fromPersonId, seq },
        standSeq: seq,
      };
    }
    case 'LEAVE_STAND': {
      return {
        ...state,
        participantsOnStand: state.participantsOnStand.filter((o) => o !== action.payload.fromPersonId),
      };
    }
    case 'SELECT_PARTICIPANT': {
      const fromPersonId = Number(action.payload);
      return {
        ...state,
        selectedParticipant: fromPersonId,
        allUnreadMessages: { ...state.allUnreadMessages, [fromPersonId]: { unreadMessagesCount: 0, unreadMessages: [] } },
      };
    }
    case 'MARK_AS_READ_ALL_MESSAGES_FROM': {
      const fromPersonId = action.payload;
      if (typeof state.allUnreadMessages[fromPersonId] === 'undefined') return state;
      return {
        ...state,
        allUnreadMessages: { ...state.allUnreadMessages, [fromPersonId]: { unreadMessagesCount: 0, unreadMessages: [] } },
      };
    }
    case 'RECEIVE_MESSAGE_FROM_SERVER': {
      const msg = action.payload;
      const fromPersonId = msg.fromPersonId;
      const obj = state.allUnreadMessages[fromPersonId];
      const count = obj ? obj.unreadMessagesCount + 1 : 1;
      const list = obj ? [...obj.unreadMessages, msg] : [msg];
      return {
        ...state,
        allUnreadMessages: { ...state.allUnreadMessages, [fromPersonId]: { unreadMessagesCount: count, unreadMessages: list } },
      };
    }
    default:
      return state;
  }
}
